import { isValidPhoneNumber } from 'libphonenumber-js'
import { normalizeUSPhoneNumber } from '@super/shared-types'

export interface ContactSearchItem {
  label: string
  sublabel?: string
  data?: {
    phone: string
    contactId?: string
    isManualEntry?: boolean
  }
}

/**
 * Filter contact items by a search query (name, email, or phone).
 * Appends a manual-entry option when the query is a valid US phone not already in results.
 */
export function filterContacts<T extends ContactSearchItem>(
  items: T[],
  query: string | undefined,
  buildManualEntry: (e164: string, raw: string) => T,
): T[] {
  if (!query?.trim()) return items

  const q = query.toLowerCase()
  const qDigits = query.replace(/\D/g, '')
  const qNormalized =
    qDigits.startsWith('1') && qDigits.length > 10 ? qDigits.slice(1) : qDigits

  let filtered = items.filter(item => {
    if (
      item.label.toLowerCase().includes(q) ||
      (item.sublabel && item.sublabel.toLowerCase().includes(q))
    )
      return true
    if (qNormalized.length >= 3 && item.data?.phone) {
      const itemDigits = item.data.phone.replace(/\D/g, '')
      const itemNormalized =
        itemDigits.startsWith('1') && itemDigits.length > 10
          ? itemDigits.slice(1)
          : itemDigits
      if (itemNormalized.includes(qNormalized)) return true
    }
    return false
  })

  if (isValidPhoneNumber(query, 'US')) {
    const e164 = normalizeUSPhoneNumber(query)
    if (e164) {
      const hasExactMatch = filtered.some(item => item.data?.phone === e164)
      if (!hasExactMatch) {
        filtered = [buildManualEntry(e164, query), ...filtered]
      }
    }
  }

  return filtered
}
